import { BrnCalendarI18n } from '@spartan-ng/brain/calendar';

const weekdays = ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'];
const months = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'] as const;

export const CS_CALENDAR_I18N: Partial<BrnCalendarI18n> = {
    firstDayOfWeek: () => 1,
    formatWeekdayName: index => ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'][index],
    labelWeekday: index => weekdays[index],
    formatHeader: (month, year) => months[month] + ' ' + year,
    formatMonth: month => months[month],
    months: () => [...months],
    labelPrevious: () => 'Předchozí měsíc',
    labelNext: () => 'Další měsíc',
};
